let statusButtonDesign = {
    mounted: function () {
        const labels = $('.vue-status-button-design > label')

        $.each(labels, function (index, label) {
            const labelText = $(label).text()
            const radioVal = index + 1

            // ラベルの中身を整形
            const imgDir = 'https://works.litalico.jp/kreisel/assets/works/img/components/status-button-design/';
            const img = '<img src="' + imgDir + 'icon_person0' + radioVal + '.png">'
            let text = '<span class="main">' + labelText + '</span>';
            if (radioVal === 1) {
                text += '<span class="small">(パート・アルバイト含む)</span>'
            }

            let radioLabel = img + '<div class="context">' + text + '</div>';
            $(label).html(radioLabel);
        });
    },
    template: '<div class="vue-status-button-design"><slot /></div>'
}